/**
 * M7 S39: the Finale screen, "Transit Priority" (spec §8.1–§8.4): the offer, the asker, the roll call, the hand-in
 * (S34's `BundlePicker`, mounted here), the confirmation and the Wire epilogue. It renders a `FinaleView` and
 * dispatches `FinaleAction`s; the host (`finaleHost.tsx`) holds the state and routes keyboard and pad input. UI
 * events only.
 */
import type { ReactNode } from 'react'
import { BundlePicker } from './BundlePicker'
import { Commit } from './Commit'
import type { BundleAction, BundleState, BundleView } from './models/bundle'
import type { ClaimPanelConfig } from './models/claim'
import type { FinaleAction, FinaleState, FinaleView } from './models/finale'
import { FinaleButtons, RollCall } from './RollCall'

export interface FinaleProps {
  view: FinaleView
  state: FinaleState
  dispatch: (a: FinaleAction) => void
  /** The hand-in's picker while the step is `bundle`. */
  bundle: { view: BundleView; state: BundleState; config: ClaimPanelConfig; dispatch: (a: BundleAction) => void } | null
}

export function Finale(p: FinaleProps): ReactNode {
  const { view: v, state: s } = p
  const press = (index: number): void => p.dispatch({ type: 'press', index })
  if (v.step === 'bundle' && p.bundle !== null) return <BundlePicker {...p.bundle} />
  return (
    <section className="sui lg-screen" data-testid="finale" data-step={v.step} role="dialog" aria-label={v.title}>
      <div className="sui-head">
        <h2 className="sui-title">{v.title}</h2>
      </div>
      {v.intro === null ? null : <p className="lg-row__meta">{v.intro}</p>}
      {v.step === 'offer' ? <FinaleButtons buttons={v.buttons} row={s.row} onPress={press} /> : null}
      {v.step === 'ask' || v.step === 'roll' ? <RollCall view={v} row={s.row} onPress={press} /> : null}
      {v.step === 'confirm' || v.step === 'done' ? <Commit view={v} row={s.row} onPress={press} /> : null}
      {s.notice === null ? null : (
        <p className="lg-notice" role="status" data-testid="finale-notice">
          {s.notice}
        </p>
      )}
    </section>
  )
}
